import { Option, SelectField, SelectFieldSyncProps } from '@almbrand/selectfield';
import { ThemeUnion } from '@almbrand/systemicons/dist/cjs/types/icon';
import { SearchFieldOption } from 'components/2-molecules/SearchFieldComponent/SearchFieldComponent';
import { PageContext } from 'context/PageContext';
import { useContext, useEffect, useState } from 'react';
import { FieldValues, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { store } from 'store/store';

export type SelectFieldComponentProps = SelectFieldSyncProps<ThemeUnion> & {
	register: UseFormRegister<FieldValues>;
	contentType: string;
	name: string;
	submitStep?: () => void;
	stepTitle?: string;
	setValue?: UseFormSetValue<FieldValues>;
	chosenOption?: number;
	onSelectionChange?: (updatedSelection: any) => void;
};

export const SelectFieldComponent: React.FC<SelectFieldComponentProps> = ({
	register,
	submitStep,
	name,
	contentType,
	setValue,
	chosenOption,
	onSelectionChange,
	isSearchable,
	...props
}) => {
	const pageContext = useContext(PageContext);
	const { theme } = pageContext ?? {};
	const [hasError, setHasError] = useState(props.hasError);
	const [defaultValue, setDefaultValue] = useState(null);
	const [renderField, setRenderField] = useState(false);

	const { onChange, name: SelectFieldName } = register(name, { required: true });

	// map from CMS options to selectField option type
	if (props.options) {
		const options: Option[] = [];
		props.options.forEach((opt) => {
			options.push({
				label: (opt as any).key || opt.label,
				value: opt.value,
			});
		});
		props.options = options;
	}

	// map from CMS
	props.menuIsOpen = !props.menuIsOpen ? undefined : true;
	props.placeHolder = (props as any).placeholder;

	const handleOnChange = (option: SearchFieldOption) => {
		setHasError(false);
		const selection = {
			target: {
				name: SelectFieldName,
				value: {
					id: name,
					label: option.label,
					value: option.value,
					type: contentType,
					stepTitle: props.stepTitle,
				},
			},
		};
		void onChange(selection);
		onSelectionChange?.(selection);
		submitStep?.();
	};

	useEffect(() => {
		const value = store.getState().calculatorForm[name]?.data?.value;
		if (value) {
			const option = props.options.find((opt) => opt.value === value);
			if (option) {
				setValue(name, { id: name, value, label: option.label, type: contentType, stepTitle: props.stepTitle }); // set value on form
				setDefaultValue(option); // set value on select field
			}
		} else if (chosenOption !== undefined) {
			const option = props.options[chosenOption];
			setValue(name, {
				id: name,
				value: option.value,
				label: option.label,
				type: contentType,
				stepTitle: props.stepTitle,
			}); // set value on form
			setDefaultValue(option); // set default value on select field if there is no value in form (e.g. when coming back to a step)
			// submitStep?.();
		}
		setRenderField(true);
	}, []);

	return (
		renderField && (
			<SelectField
				hasError={hasError}
				{...props}
				icon={{ iconProp: { icon: 'chevron_down' } }}
				themeName={theme}
				iconPosition='right'
				onChange={handleOnChange}
				isSearchable={!!isSearchable}
				defaultValue={defaultValue}
			/>
		)
	);
};
